/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconPlaystationTriangle = createReactComponent("outline", "playstation-triangle", "IconPlaystationTriangle", [["path", { "d": "M12 21a9 9 0 0 0 9 -9a9 9 0 0 0 -9 -9a9 9 0 0 0 -9 9a9 9 0 0 0 9 9z", "key": "svg-0" }], ["path", { "d": "M7.5 15h9l-4.5 -8z", "key": "svg-1" }]]);

export { IconPlaystationTriangle as default };
//# sourceMappingURL=IconPlaystationTriangle.mjs.map
